import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import SEO from '../../components/SEO';
import { useLanguage } from '../../i18n/LanguageContext';

// Rendered for language routes that exist in the codebase but whose
// translations are not yet approved (currently Danish /da/*). The page is
// noindexed and never linked, so unfinished language versions cannot leak
// into search results or show English text under an indexable /da URL.
const LanguageComingSoon = () => {
  const { lang } = useLanguage();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #2d2d2d 100%)',
      paddingTop: '4rem'
    }}>
      <SEO
        title="Hestia Doors — language version coming soon"
        description="This language version of hestiadoors.com is not published yet."
        noindex
      />
      <Navigation />
      <div style={{ maxWidth: '48rem', margin: '0 auto', padding: '6rem 1.5rem', textAlign: 'center' as const }}>
        <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'white', marginBottom: '1rem' }}>
          Hestia Doors
        </h1>
        <p style={{ color: '#d1d5db', fontSize: '1.125rem', lineHeight: 1.7, marginBottom: '2rem' }}>
          {lang === 'da'
            ? 'Denne sprogversion er ikke tilgængelig endnu. Besøg den engelske eller estiske version af siden.'
            : 'This language version is not available yet.'}
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' as const }}>
          <Link to="/" style={{ backgroundColor: '#dfa926', color: 'black', fontWeight: 600, padding: '0.85rem 1.75rem', borderRadius: '0.5rem', textDecoration: 'none' }}>
            English
          </Link>
          <Link to="/et" style={{ border: '2px solid #dfa926', color: '#dfa926', fontWeight: 600, padding: '0.85rem 1.75rem', borderRadius: '0.5rem', textDecoration: 'none' }}>
            Eesti
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LanguageComingSoon;
